import {
  SEND_FORGOT_PASSWORD_REQUEST,
  SEND_FORGOT_PASSWORD_SUCCESS,
  SEND_FORGOT_PASSWORD_FAIL,
  VERIFICATION_OTP_FORGOT_PASSWORD_REQUEST,
  VERIFICATION_OTP_FORGOT_PASSWORD_SUCCESS,
  VERIFICATION_OTP_FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_FORGOT_PASSWORD
} from '../../constants/auth'

// **  Initial State
const initialState = {
  userData: {},
  otp: '',
  loading: false,
  error: ''
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        userData: action.data,
        [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName],
        [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case 'LOGOUT':
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, ...obj }
    case SEND_FORGOT_PASSWORD_REQUEST:
      return { ...state, loading: true }
    case SEND_FORGOT_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: '' }
    case SEND_FORGOT_PASSWORD_FAIL:
      return { ...state, loading: false, error: action.payload }
    case VERIFICATION_OTP_FORGOT_PASSWORD_REQUEST:
      return { ...state, loading: true }
    case VERIFICATION_OTP_FORGOT_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: '', otp: action.payload }
    case VERIFICATION_OTP_FORGOT_PASSWORD_FAIL:
      return { ...state, loading: false, error: action.payload }
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true }
    case RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: '' }
    case RESET_PASSWORD_FAIL:
      return { ...state, loading: false, error: action.payload }
    case RESET_FORGOT_PASSWORD:
      return { ...state, loading: false, error: '', otp: '' }
    default:
      return state
  }
}

export default authReducer
